import React, { useEffect } from "react";
import Nav from "./Nav";
import Reactplayer from "./ReactPlayer";
import AOS from "aos";
import "aos/dist/aos.css";
import TextCarasoul from "./TextCarasoul";
import { Link } from "react-router-dom";
import HomeSplayer from "./HomeSplayer";
import TextCarasoul2 from "./TextCarasoul2";
import Footer from "./Footer";
// import { popupModal } from "../atoms/atom";
import { useRecoilState } from "recoil";
import Popup from "./Popup";
import { Zoom, Bounce, Fade, Flip } from "react-reveal";

const Home = () => {
  // const [open, setOpen] = useRecoilState(popupModal);

  useEffect(() => {
    AOS.init();
    // setTimeout(() => {
    //   setOpen(true);
    //   console.log("checking open", open);
    // }, 6000);
  }, []);

  return (
    <div className="">
      <Nav active="" />
      <div className="max-w-[1320px] md:mx-auto mx-4 flex items-center justify-center  md:justify-between flex-wrap mt-8 md:mt-12 pb-8">
        <Bounce left>
          <div className="flex-grow mx-auto max-w-[600px]">
            <h1 className="sm:text-[48px] capitalize text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
              Why suffer Editing While you must be creating something new?
            </h1>
            {/* <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#323a41]">
            Your videos edited right, <span> 100% stress free </span>
          </h1> */}
            <p className="mt-6 text-2xl leading-9 text-[#4f4f4f] text-center lg:text-left">
              Making your Video Editing 100% Stress Free Versatile Team of Video
              Editors working with 256 Video Creators Worldwide{" "}
            </p>
            {/* <div className="mt-4 mb-10 text-center md:mt-8 lg:text-left">
            <Link to="/content-creators">
              <button className="md:p-4 p-3 m-1 mt-2 mr-[1px] md:text-xl text-lg font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#323a41]">
                Learn more!
              </button>
            </Link>
            <button
              // onClick={() => setOpen(true)}
              className="p-3 m-1 mt-1 mr-1 text-lg font-semibold transition duration-200 ease-out  md:p-4 md:mt-2 md:text-xl bg-gray-200 hover:bg-gray-300 text-[#323a41]"
            >
              Free video editing cheat sheat
            </button>
          </div> */}
          </div>
        </Bounce>
        <Bounce right>
          <div className="flex-grow sm:min-w-[450px] min-w-[290px]  max-w-[591px] mx-auto  px-2 sm:px-4">
            <Reactplayer url="https://youtu.be/xnMk-mXkGbw" />
          </div>
        </Bounce>
      </div>
      <Fade bottom>
        <img
          src={require("../images/mountain1.png")}
          alt=""
          className="w-[100vw] h-80 hidden lg:block"
        />
      </Fade>
      <div className="-mt-7">
        <Flip top>
          <div className="max-w-[1200px] pt-16 overflow-x-scroll scrollbar-hide px-4 md:mx-auto mx-3">
            <img
              src={require("../images/brandList.png")}
              alt=""
              className="h-20 mx-auto opacity-50 min-w-[880px]"
            />
          </div>
        </Flip>
        <div
          data-aos="fade-up"
          // data-aos-delay="400"
          data-aos-duration="1000"
          className="w-full mt-16 py-16 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between"
        >
          <div className="flex-grow xl:max-w-[500px] max-w-[700px]">
            <Bounce left>
              <h1 className="md:text-[43px] text-[30px] capitalize text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
                We all know that compared to shooting videos, editing them is NO
                FUN.
              </h1>
            </Bounce>
          </div>
          <Bounce right>
            <div className="flex-grow max-w-[700px] ">
              <p className="mt-4 text-2xl leading-9 text-[#4f4f4f] text-center xl:text-left">
                If you're a content creator or business owner, editing video
                just isn't the best use of your time. You've got better things
                to do.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
                But hiring an editor to do it for you is like taking on another
                employee – and often an expensive one.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
                There's never been a simple way to hand over your footage for
                editing, without a bunch of extra legwork.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
                There's never been a simple way to hand over your footage for
                editing, without a bunch of extra legwork.
              </p>
              <p className="mt-3 text-2xl leading-9 text-[#4f4f4f]  text-center  ">
                Until now...
              </p>
            </div>
          </Bounce>
        </div>
      </div>
      <Zoom>
        <div className="bg-black border-8 border-red-600 bg-opacity-95">
          <TextCarasoul />
        </div>
      </Zoom>
      <Flip bottom>
        <div className="my-32 max-w-[900px] mx-auto px-5">
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            NEVER SAIL ON TWO BOATS
          </h1>
          <p className="mt-3 text-2xl leading-9 text-[#4f4f4f]  text-center  ">
            We all know how frustrating it gets when you have to edit your
            videos while keeping a list of videos to shoot. But hiring an editor
            to do it for you is like taking on another employee – and often an
            expensive one. There's never been a simple way to hand over your
            footage for editing, without a bunch of extra legwork.
          </p>
        </div>
      </Flip>
      <div className="border-8 border-red-600">
        <div className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap">
          <Bounce left>
            <div className="flex-grow max-w-[540px] mb-6">
              <img src={require("../images/homeT1.png")} alt="" />
            </div>
          </Bounce>
          <Bounce right>
            <div className="flex-grow max-w-[600px]">
              <h1 className=" md:text-[30px] text-[22px] text-center lg:text-left  font-semibold md:leading-[60px] mb-3  text-[#1b0c3e] mt-3">
                {`"How unlimited is "unlimited"?"`}
              </h1>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center lg:text-left ">
                {`There's absolutely NO limit to the amount of video projects you can submit to us – and we offer a plan that allows you to make as many revisions as you’d like.`}
              </p>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center lg:text-left ">
                {`Your editor will work on one video at a time for a fast turnaround and quality you'll be proud of, with no unnecessary back-and-forth slowing you down.`}
              </p>
            </div>
          </Bounce>
        </div>
        <div className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap">
          <Bounce left>
            <div className="flex-grow max-w-[600px] mb-12">
              <h1 className=" md:text-[30px] text-[22px] text-center lg:text-left  font-semibold md:leading-[60px] mb-3  text-[#1b0c3e] mt-3">
                {`"Can you help me beat my deadlines?"`}
              </h1>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center lg:text-left ">
                {`With Video Husky you can keep your momentum going as we get your first draft back to you within 1-2 business days depending on the project complexity. After that, your revisions will be turned around in just 1 day.`}
              </p>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center lg:text-left ">
                {`Your account manager will oversee the entire workflow so you can comfortably hit deadlines AND have one less thing to worry about.`}
              </p>
            </div>
          </Bounce>
          <Bounce right>
            <div className="flex-grow max-w-[540px] mb-6">
              <img src={require("../images/homeT2.png")} alt="" />
            </div>
          </Bounce>
        </div>
      </div>
      <>
        {/* <div className="pt-1 bg-white">
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1000"
            className="my-32 max-w-[900px] mx-auto px-5"
          >
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              You're just 3 easy steps away from never having to edit another
              video
            </h1>
          </div>
          <div className=" max-w-[1320px] mx-auto flex flex-wrap justify-around ">
            <div className="p-8 md:p-2 my-4  max-w-[300px]">
              <img
                src={require("../images/offload.png")}
                alt=""
                className="w-20 h-20 mx-auto mb-9"
              />
              <h1 className="text-[24px] text-center font-semibold mb-3 text-[#323a41] mt-3">
                {`Offload your assets to us`}
              </h1>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center">
                {`Join Video Husky and send us your footage and editing instructions in minutes.`}
              </p>
            </div>
            <div className="p-8 md:p-2 my-4  max-w-[300px]">
              <img
                src={require("../images/firstDraft.png")}
                alt=""
                className="w-20 h-20 mx-auto mb-9"
              />
              <h1 className="text-[24px] text-center font-semibold mb-3 text-[#323a41] mt-3">
                {`Get your first draft in 1-2 business days`}
              </h1>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#4f4f4f]  text-center">
                {`While we edit your video, you can finally put this time to better use.`}
              </p>
            </div>
            <div className="p-8 md:p-2 my-4 max-w-[300px]">
              <img
                src={require("../images/revisions.png")}
                alt=""
                className="w-20 h-20 mx-auto mb-9"
              />
              <h1 className="text-[24px] text-center font-semibold mb-3 text-[#323a41] mt-3">
                {`Request any revisions, then start your next project!`}
              </h1>
              <p className="mt-5 md:text-[20px] text-[18px] leading-8 text-[#52626f]  text-center">
                {`Share your feedback with your editor. Once you’re happy, we’ll start your next video.`}
              </p>
            </div>
          </div>
          <div className="py-10 my-8 text-center md:py-16">
            <Link to="/content-creators">
              <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#323a41] text-center mx-auto">
                Learn more!
              </button>
            </Link>
          </div>
        </div> */}

        {/* <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="my-28 max-w-[900px] mx-auto px-5"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
            Everything you need to offload your video editing
          </h1>
        </div> */}
        {/* <div className=" max-w-[1320px] mx-auto flex flex-wrap xl:justify-between justify-around">
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog1.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`Account manager & editor *`}
            </h1>
            <p className=" text-[18px] text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`Hand over your heavy workload and ease the pressure.`}
            </p>
          </div>
        </div>
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog2.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`First draft in 1-2 days`}
            </h1>
            <p className=" text-[18px] text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`Depending on the complexity of your videos, we’ll deliver a draft to you within this timeframe.`}
            </p>
          </div>
        </div>
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog3.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`Unlimited video requests *`}
            </h1>
            <p className=" text-[18px] text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`Release more content, more consistently, with a smoother video creation process.`}
            </p>
          </div>
        </div>
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog4.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`Project dashboard *`}
            </h1>
            <p className=" text-[18px]  text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`Get more clarity by easily overseeing all your projects in one place.`}
            </p>
          </div>
        </div>
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog5.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`Video proofing tool *`}
            </h1>
            <p className=" text-[18px]  text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`Get every video frame right on the money with our tap-and-comment feature.`}
            </p>
          </div>
        </div>
        <div className="border m-2 my-4 md:min-w-[620px] md:max-w-[620px] p-8 bg-white flex flex-wrap justify-evenly items-center">
          <img
            src={require("../images/dog6.png")}
            alt=""
            className="mr-6 h-28 w-28"
          />
          <div className="max-w-[410px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#323a41] mt-3">
              {`YouTube upload *`}
            </h1>
            <p className=" text-[18px]  text-[#52626f]  text-center sm:text-left mt-4 sm:mt-2">
              {`We'll upload your videos to YouTube or Vimeo for you, for free.`}
            </p>
          </div>
        </div>
      </div> */}
        {/* <div className="py-10 my-8 text-center md:py-16">
        <Link to="/how-it-works">
          <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-gray-200 hover:bg-gray-300 transition duration-200 ease-out text-[#323a41] text-center mx-auto">
            And more!
          </button>
        </Link>
      </div> */}
      </>

      <div className="bg-white ">
        <Flip bottom>
          <div className="w-full pt-24 pb-20 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between">
            <div className="flex-grow xl:max-w-[480px] max-w-[700px]">
              <h1 className="md:text-[43px] text-[30px] capitalize text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
                See what we've done for other video creators like you
              </h1>
            </div>
            <div className="flex-grow max-w-[730px] ">
              <p className="mt-4 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                We connect with your vision, so your videos get the look and
                feel you want - every time.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                All of our editors and project managers will learn how to grasp
                your individual style and create videos you’ll be proud of,
                minus the need to look over their shoulders.
              </p>
            </div>
          </div>
        </Flip>
        <div className="max-w-[1350px] mx-auto flex flex-wrap xl:justify-between justify-around">
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=Pog0RZ5rwFc" />
          </div>
          <div className="flex-grow min-w-[300px]  m-4 my-6 border sm:min-w-[400px] sm:max-h-[400px]">
            <HomeSplayer url="https://www.youtube.com/watch?v=PVkZAxBLFRI&ab_channel=BETZMANNVLOGS" />
          </div>
          <div className="flex-grow min-w-[300px] m-4 my-6 border sm:min-w-[400px] sm:max-h-[400px]">
            <HomeSplayer url="https://www.youtube.com/watch?v=q2ZuXwJMuEY&ab_channel=DIYDalia" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=w3GmNKEZTfc&ab_channel=TheNailsQueen" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url=" https://www.youtube.com/watch?v=tmE9wRGkRqY" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=yC7lI5XRiW0&ab_channel=MarkHarrison" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=bevRVooE1J0&ab_channel=DaniyalSheikh" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=q1tqPAEEKbc&ab_channel=YashmaGill" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-h-[400px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=w0cdQwY75vk&ab_channel=SuppleChicTV" />
          </div>
          {/* <div className="flex-grow min-w-[300px] max-w-[300px] m-4 my-6 border">
            <HomeSplayer url=" https://www.youtube.com/watch?v=Qd6rGwlmcmA" />
          </div>
          <div className="flex-grow min-w-[300px] max-w-[300px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=hMZagmX3d0k&ab_channel=CerealEntrepreneur-JordanSteen " />
          </div>
          <div className="flex-grow min-w-[300px] max-w-[300px] m-4 my-6 border">
            <HomeSplayer url="https://www.youtube.com/watch?v=zhOePhSyyh0&ab_channel=CarolynMarie" />
          </div> */}
        </div>

        <div className="py-10 my-8 text-center md:py-16">
          <Link to="/reviews">
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#508dff] rounded-md transition duration-200 ease-out text-[#fff] text-center mx-auto hover:shadow-2xl">
              See more examples
            </button>
          </Link>
        </div>

        {/* <div className="bg-black bg-opacity-95">
          <TextCarasoul2 />
        </div> */}
      </div>
      <>
        {/* <div className="lg:relative">
        <img
          src={require("../images/groupimg.jpg")}
          className="w-[1100px] mt-28 h-auto mx-auto"
          alt=""
        />
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="max-w-[1000px] p-6 mx-auto bg-white lg:absolute lg:-bottom-[440px] right-0 left-0"
        >
          <div className="w-full pt-6  px-[20px] md:px-2  mx-auto flex  flex-wrap justify-center xl:justify-between">
            <div className="flex-grow  max-w-[360px]">
              <h1 className="md:text-[43px] text-[30px] text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
                About Team Husky
              </h1>
              <div className="py-10 my-8">
                <Link to="/about">
                  <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-gray-200 hover:bg-gray-300 transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto ">
                    {`Read our story >`}
                  </button>
                </Link>
              </div>
            </div>
            <div className="flex-grow max-w-[560px] ">
              <p className="mt-4 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                Video Husky is a happy team of editors, account manager,
                customer success agents, a head of operations, and me, Justin
                the founder!
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                But it didn't start off that way.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                While running video ads as a Facebook marketer, I got stuck
                under a huge workload and increasing pressure to meet client
                demands, with no clear way forward.
              </p>
              <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
                Until I teamed up with an editor to try something different...
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:h-[600px]"></div>
      <div
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="1000"
        className=" max-w-[900px] mx-auto px-5"
      >
        <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
          With Video Husky you'll never waste another minute editing
        </h1>
        <p className="mt-3 text-2xl leading-9 text-[#52626f]  text-center  ">
          Join hundreds of other video creators who've freed themselves from
          editing their own videos.
        </p>
        <div className="py-10 my-8 text-center md:py-16">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#323a41] text-center mx-auto">
              Learn more!
            </button>
          </Link>
        </div>
      </div> */}
      </>
      <Popup />
      <Footer />
    </div>
  );
};

export default Home;

// font-family: "Avenir Next","Helvetica Neue","HelveticaNeue",Helvetica,Arial,sans-serif;
